import React, { useContext, useEffect, useState, useRef } from "react";
import { Icon, ContextualMenu, IconButton, TooltipHost,DirectionalHint } from "@fluentui/react";
import "./StudyListTab.css";
import CXRContextMenuTab from "../CXRContextMenuTab/CXRContextMenuTab";
import themeContext from "../../../../context/theme/ThemeContext";

const StudyListTab = (props) => {
  const [reportTemplates, setReportTemplates] = useState();
  const {themeName,getThemeColor} = useContext(themeContext);
  const toolTipProps = {
    calloutProps: {
      isBeakVisible: true,
      gapSpace: 12,
      styles: {
        beak: { background: getThemeColor("tooltip") },
        beakCurtain: { background: getThemeColor("tooltip") },
        calloutMain: { background: getThemeColor("tooltip"), borderRadius: "5px" },
      },
    },
  };
  return (
    <>
      <div className={props.contentClass}>
        <Icon className="icon">{props.icon}</Icon>
        <h4
          className={`textContent-study-list ${
            props.active ? "studylist-highlight-tab" : ""
          }`}
        >
          {props.title}
        </h4>
        {props.showCloseButton && (
          <TooltipHost
            content="Close All Tabs"
            directionalHint={DirectionalHint.bottomCenter}
            tooltipProps={toolTipProps}
          >
            <IconButton
              className="study-list-tab-close-button"
              iconProps={{ iconName: "Cancel" }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                props.onClose?.();
              }}
              ariaLabel="Close All Tabs"
            />
          </TooltipHost>
        )}
        <>
          {props.count > 0 && (
              <div className={"tab-notification-count"}>
                <span className="study-list-tab-count-popup">
                  {props.count}
                </span>
              </div>
          )}
        </>
        {props.active && themeName !== "light" && (
          <div className="hide-border-bottom-border"></div>
        )}
      </div>
    </>
  );
};

export default StudyListTab;
